import $ from 'jquery';

const settings = {
  delay: 400,
  selectors: {
    menu: '.menu-icon',
    search: '.search-icon',
    text: '#edit-box-text',
    input: '#edit-keywords',
  },
};

export default class Toolbar {
  constructor(element, context) {
    this.context = context;
    this.element = element;
    this.$element = $(element);
    this.settings = settings;
    this.$body = this.getBody();
    this.$menuBtn = this.getBtn('menu');
    this.$searchBox = this.getBox(context);
    this.searchText = this.getText(context);
    this.menuHandler = this.menuHandler.bind(this);
    this.resetSearchInput = this.resetSearchInput.bind(this);
    this.setPlaceholderText();
    this.listen();
  }

  getBody() {
    return $(document.body, this.context);
  }

  getBtn(type) {
    return $(this.settings.selectors[type], this.element);
  }

  getText(context) {
    return $(this.settings.selectors.text, context).val();
  }

  getBox(context) {
    const $input = $(this.settings.selectors.input, context);
    $input.val('');
    return $input;
  }

  setPlaceholderText() {
    return this.$searchBox.attr('placeholder', this.searchText);
  }

  menuHandler() {
    return this.$body.is('.menu-active') ? this.off() : this.on();
  }

  off() {
    this.$body.removeClass('menu-active');
  }

  on() {
    this.$body.addClass('menu-active');
  }

  resetSearchInput() {
    // This is a workaround to overcome the default dd-search.js search
    // input scripted behaviors.
    if (this.searchText === this.$searchBox.val()) {
      this.$searchBox.val('');
    }
  }

  listen() {
    this.$menuBtn.bind('click', this.menuHandler);

    // Listening so that we can override previously set scripted behaviors.
    this.$searchBox.bind('blur focus', this.resetSearchInput);
  }
}
